import { SelectOption } from '../models';

export enum MiddlePoint {
  WITH = 'WITH',
  WITH_MULTI = 'WITH_MULTI',
  WITHOUT = 'WITHOUT',
}

export class MiddlePointHelper {
  private static readonly labelMap: Record<MiddlePoint, string> = {
    [MiddlePoint.WITH]: 'With single',
    [MiddlePoint.WITH_MULTI]: 'With multi',
    [MiddlePoint.WITHOUT]: 'Without',
  };

  static enumToLabelKey(middlePoint: MiddlePoint): string {
    return this.labelMap[middlePoint] ?? '';
  }

  private static getConstantList(): MiddlePoint[] {
    return [MiddlePoint.WITH, MiddlePoint.WITH_MULTI, MiddlePoint.WITHOUT];
  }

  static getOptions(): SelectOption[] {
    return this.getConstantList().map((middlePoint) => ({
      label: this.enumToLabelKey(middlePoint),
      value: middlePoint,
    }));
  }
}
